import FeedTypeBlock from '@cont/FeedTypeBlock/FeedTypeBlock';

const MIN_FEED_COUNT = 3;

const RenderFeedBlock = (props) => {
  const {
    item: feed,
    index,
    goalInfo = {},
    lastPrimarySource,
    type,
    dataAnalytics
  } = props || {};
  const seeAllLink = `/goal/${goalInfo.goalSlug}/${goalInfo.uid}/${feed.type}`;
  const viewAllHref = '/goal/[goalSlug]/[goalUID]/[type]';
  const feedProps = {};
  const feedCount = feed?.extraBlockInfo?.count;
  const viewAllLink = feedCount > MIN_FEED_COUNT ? seeAllLink : null;

  return (
    <FeedTypeBlock
      lastPrimarySource={lastPrimarySource}
      goalUID={goalInfo.uid}
      goalSlug={goalInfo.goalSlug}
      feedBlock={feed}
      key={feed.type}
      goal={goalInfo}
      type={type}
      feedProps={feedProps}
      dataAnalytics={dataAnalytics}
      index={index}
      viewAllLink={viewAllLink}
      viewAllHref={viewAllHref}
    />
  );
};

export default RenderFeedBlock;
